import { BrowserRouter } from "react-router-dom";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import AppRoutes from "./routes/Route/Routes";
import { createContext, useState, useMemo } from "react";
import { useConfig } from "./context/ConfigProvider";
import { IAquaRequest } from "./typings/interfaces/Requests/AquaRequest";
import { IBioRequest } from "./typings/interfaces/Requests/BioRequest";
import { ITERRequest } from "./typings/interfaces/Requests/TERRequest";
import { IENVRequest } from "./typings/interfaces/Requests/ENVRequest";
import { IAVIRequest } from "./typings/interfaces/Requests/AVIRequest";
import { IFRWRequest } from "./typings/interfaces/Requests/FRWRequest";
import { ILabSampleModelRequest } from "./typings/interfaces/Requests/LabSampleModelRequest";
import { Helmet } from "react-helmet";
import "./styles/CspUtilities.css";

// moved into component to read runtime config

export const AquaMetaContext = createContext<any>({});
export const BioMetaContext = createContext<any>({});
export const TERMetaContext = createContext<any>({});
export const ENVMetaContext = createContext<any>({});
export const AVIMetaContext = createContext<any>({});
export const PSHMetaContext = createContext<any>({});
export const FRWMetaContext = createContext<any>({});

function App() {
  const cfg = useConfig();
  const stripePromise = useMemo(() => loadStripe(cfg.REACT_APP_STRIPE_PUBLIC_KEY || ""), [cfg.REACT_APP_STRIPE_PUBLIC_KEY]);
  const UAT_AUTH_SCREEN = cfg.REACT_APP_UAT_AUTH_SCREEN;
  const updateAquaMeta = (newValue: IAquaRequest) => {
    setAquaMetaContext({ aquaMeta: newValue, updateAquaMeta });
  };

  const [aquaMeta, setAquaMetaContext] = useState<any>({
    aquaMeta: {},
    updateAquaMeta,
  });

  const updateBioMeta = (newValue: IBioRequest) => {
    setBioMetaContext({ BioMeta: newValue, updateBioMeta });
  };

  const [BioMeta, setBioMetaContext] = useState<any>({
    BioMeta: {},
    updateBioMeta,
  });
  const updateENVMeta = (newValue: IENVRequest) => {
    setENVMetaContext({ ENVMeta: newValue, updateENVMeta });
  };

  const [ENVMeta, setENVMetaContext] = useState<any>({
    ENVMeta: {},
    updateENVMeta,
  });
  const updateTERMeta = (newValue: ITERRequest) => {
    setTERMetaContext({ TERMeta: newValue, updateTERMeta });
  };

  const [TERMeta, setTERMetaContext] = useState<any>({
    TERMeta: {},
    updateTERMeta,
  });

  const updateAVIMeta = (newValue: IAVIRequest) => {
    setAVIMetaContext({ AVIMeta: newValue, updateAVIMeta });
  };

  const [AVIMeta, setAVIMetaContext] = useState<any>({
    AVIMeta: {},
    updateAVIMeta,
  });
  const updatePSHMeta = (newValue: ILabSampleModelRequest) => {
    setPSHMetaContext({ AVIMeta: newValue, updateAVIMeta });
  };

  const [PSHMeta, setPSHMetaContext] = useState<any>({
    PSHMeta: {},
    updatePSHMeta,
  });
  const updateFRWMeta = (newValue: IFRWRequest) => {
    setFRWMetaContext({ FRWMeta: newValue, updateFRWMeta });
  };

  const [FRWMeta, setFRWMetaContext] = useState<any>({
    FRWMeta: {},
    updateFRWMeta,
  });

  return (
    <>
      <Helmet>
        {UAT_AUTH_SCREEN === "YES" && (<script src="https://assets.dcube.cloud/scripts/wogaa.js"></script>)}
        {UAT_AUTH_SCREEN === "NO" && (<script src="https://assets.wogaa.sg/scripts/wogaa.js"></script>)}
      </Helmet>
      <BrowserRouter basename="/eservices">
        <AVIMetaContext.Provider value={{ AVIMeta }}>
          <AquaMetaContext.Provider value={{ aquaMeta }}>
            <BioMetaContext.Provider value={{ BioMeta }}>
              <TERMetaContext.Provider value={{ TERMeta }}>
                <ENVMetaContext.Provider value={{ ENVMeta }}>
                  <PSHMetaContext.Provider value={{ PSHMeta }}>
                    <FRWMetaContext.Provider value={{ FRWMeta }}>
                      <Elements stripe={stripePromise}>
                        <AppRoutes />
                      </Elements>
                    </FRWMetaContext.Provider>
                  </PSHMetaContext.Provider>
                </ENVMetaContext.Provider>
              </TERMetaContext.Provider>
            </BioMetaContext.Provider>
          </AquaMetaContext.Provider>
        </AVIMetaContext.Provider>
      </BrowserRouter>
    </>
  );
}

export default App;
